import type { ReactNode } from 'react';
import type { FieldPath, FieldValues, UseFormReturn } from 'react-hook-form';

import { FieldError, TextField, TextInput } from '@gitbook/spine-react';

import { IconPickerField } from './IconPickerField';

export function TitleAndIconField<TFieldValues extends FieldValues>(props: {
    form: UseFormReturn<TFieldValues>;
    titleName: FieldPath<TFieldValues>;
    iconName: FieldPath<TFieldValues>;
    children?: ReactNode;
    minLength: number;
    maxLength: number;
    disabled?: boolean;
    autoFocus?: boolean;
}) {
    const { minLength, maxLength, children, form, iconName, titleName, disabled, autoFocus } =
        props;
    return (
        <TextField
            form={form}
            name={titleName}
            required
            minLength={minLength}
            maxLength={maxLength}
        >
            {children}
            <div className="flex items-center gap-2">
                <IconPickerField form={form} name={iconName} disabled={disabled} />
                <TextInput className="flex-1" disabled={disabled} autoFocus={autoFocus} />
            </div>
            <FieldError />
        </TextField>
    );
}
